module.exports = __webpack_public_path__ + "img/videoMonitoring.0252d9a4.png";